import React from "react";
import ProductRepository from "../../repository/ProductRepository";
import StandardFormComponent from "../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import FormToastComponent from "../basics/FormToastComponent";
import FormHelper from "../../helpers/FormHelper";
import CheckPermissions from "../../helpers/CheckPermissions";
import UserRolesEnum from "../../enums/UserRolesEnum";
import ProductTextFormComponent from "./forms/ProductTextFormComponent";
import Module from "../../models/module/Module";
import Product from "../../models/product/Product";
import { ModuleRepository, WebsiteRepository } from "../../repository";
import ProductContent from "../../models/product/ProductContent";
import { LoaderComponent } from "../basics/layout";
import Website from "../../models/website/Website";

class ProductFormComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            lng: props.match.params.language,
            module: Module.get(),
            model: this.props.model !== undefined ? this.props.model : new ProductContent(),
            loading: true,
            settings: {},
            isEdit: false,
            roles: this.props.user.roles,
        };

        this.table_ref = React.createRef();

        this.customProps = { ...this.props };
        this.isManager = CheckPermissions.role(this.state.roles, UserRolesEnum.MANAGER) && !CheckPermissions.role(this.state.roles, UserRolesEnum.RESELLER);
    }

    componentDidMount() {
        let promises = [
            ModuleRepository.getSettings(),
            WebsiteRepository.get(Website.get()),
            ModuleRepository.get(this.state.module.id),
        ];

        if (this.props.get_promise !== undefined) {
            promises.push(this.props.get_promise);
        }

        Promise.all(promises)
            .then(result => {
                let moduleSettingsResult = result[0];
                let websiteGetResult = result[1];
                let moduleGetResult = result[2];
                let promiseGetResult = result[3];

                let settings = {};
                if (moduleSettingsResult !== undefined && moduleSettingsResult.data !== undefined) {
                    settings = moduleSettingsResult.data.settings;
                }

                let currentModule = this.state.module;
                currentModule.module = moduleGetResult.module;
                Module.set(currentModule);

                let model = this.state.model;
                if (promiseGetResult !== undefined) {
                    model = Product.fromJson(promiseGetResult);
                    let content = model.contents.filter(content => content.language === this.props.match.params.language)[0];

                    model.title = content.title;
                    model.summary = content.summary;
                    model.content = content.content === '[]' ? {} : JSON.parse(content.content);
                    model.pdf_document = content.pdf_document;
                    model.tags = content.tags;

                    model = Module.fillModel(this.state.module, this.state.lng, model);

                    settings.tags = content.existing_tags;
                }

                this.setState({
                    loading: false,
                    settings: settings,
                    model: model,
                    module: Module.get(),
                    lng: this.state.lng ? this.state.lng : websiteGetResult.default_language,
                    isEdit: model.id
                });
            });
    }

    getBeforeSubmit = (element) => ProductTextFormComponent.fields_image_before_submit(element)

    success = () => {
        FormToastComponent.successTrans("Product", "Default.saved");
        this.props.history.push('/module/' + this.props.slug + '/' + Module.getId() + '/overview');
    }

    error = (message) => FormHelper.handleSubmitError(this, message);

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.customProps}
                ref={this.table_ref}
                parent={this}
                className="product"
                validationSchema={Product.schema(this.state)}
                model={this.state.model}
                formSubmit={(values, formikActions) => {
                    this.getBeforeSubmit.bind();
                    return this.getBeforeSubmit(this.table_ref.current)
                        .then(() => {
                            if (this.state.isEdit) {
                                return ProductRepository.update({ id: values.id, language: this.props.match.params.language, ...values })
                                    .then(() => this.success())
                                    .catch(error => this.error(error))
                            } else {
                                return ProductRepository.create(values)
                                    .then(() => this.success())
                                    .catch(error => this.error(error))
                            }
                        });
                }}
                formErrors={this.state.form_errors}
                fields={ProductTextFormComponent.fields(this.state)}
            />
        );
    }
}

export default withRouter(ProductFormComponent);